/** @jsxImportSource @emotion/react */
import React from 'react';
import { DatePicker, Form, Select, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import commonStyles from '../../../../../styles/commonStyles';
import { datePickerFormat } from '../../../../../i18n';
import { formStyles } from '../constants';
import { ORIGIN_TYPES } from '../constants';

/** Origin type (propagation method) and origin date fields */
const OriginSection: React.FC = () => {
  const { t } = useTranslation('plantings');
  const originTypeOptions = ORIGIN_TYPES.map((value) => ({ value, label: t(`form.origin.type.${value}`) }));
  return (
  <>
    <Typography.Title level={5} css={formStyles.sectionTitle}>
      {t('form.origin.title')}
    </Typography.Title>

    <Form.Item
      label={t('form.origin.method')}
      name="originType"
      tooltip={t('form.origin.methodTooltip')}
    >
      <Select allowClear placeholder={t('status.notSet')} options={originTypeOptions} />
    </Form.Item>

    <Form.Item
      label={t('form.origin.date')}
      name="originDate"
      tooltip={t('form.origin.dateTooltip')}
    >
      <DatePicker format={datePickerFormat()} css={commonStyles.fullWidth} allowClear />
    </Form.Item>
  </>
  );
};

export default OriginSection;
